var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"foliomap",staticStyle:{"z-index":"2"},style:({ height: _vm.height + 'px', minHeight: '400px' }),attrs:{"id":"foliomap"}})
}
var staticRenderFns = []

export { render, staticRenderFns }